import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectActiveTab, selectAuth, selectCollapsedSidebar, setActiveTab, setCollapseSidebar } from '../redux/features/authSlice'
import { GiHamburgerMenu } from 'react-icons/gi';
import { useGetProfileQuery } from '../redux/api/profileApi/profileApi';
import CustomSidebar from './CustomSidebar';
import { useOnClickOutside } from 'usehooks-ts';
import jwt_decode from "jwt-decode";
import { IAuthUser } from '../redux/features/authSlice/authSlice.types';
import { useNavigate } from 'react-router-dom';

const CustomHeader = () => {
    const dispatch = useDispatch();
    const collapsedSidebar = useSelector(selectCollapsedSidebar);
    const activeTab = useSelector(selectActiveTab);
    const { token } = useSelector(selectAuth);
    const authData: IAuthUser = token ? jwt_decode(token) : null;
    const { data: profileData, isSuccess } = useGetProfileQuery(authData?.id);
    const navigate = useNavigate();

    const dropDownRef = useRef<HTMLDivElement>();

    useOnClickOutside(dropDownRef, () => dispatch(setCollapseSidebar(true)));

    return (
        <div className='bg-white px-4 py-2 sticky top-0' ref={dropDownRef}>
            <div className='flex items-center justify-between'>
                <div className='flex items-center gap-4 text-2xl font-bold'>
                    <div onClick={() => dispatch(setCollapseSidebar(!collapsedSidebar))} className='bg-primary p-1 text-3xl rounded text-white cursor-pointer hover:scale-105 transition-all shadow'>
                        <GiHamburgerMenu />
                    </div>
                    <div className=''>{activeTab}</div>
                </div>
                {isSuccess && <div onClick={() => {
                    dispatch(setActiveTab('Profile'))
                    navigate('/profile');
                }} className='overflow-hidden rounded-full border-2 p-[1px] cursor-pointer'>
                    <img src={profileData?.image || "https://i.ibb.co/8MgR8kC/images.png"} className='h-10 w-10 rounded-full' alt='profile' />
                </div>}
            </div>
            {!collapsedSidebar && <div className='absolute top-0 left-0'>
                <CustomSidebar />
            </div>}
        </div>
    )
}

export default CustomHeader